import { ObjectFieldsChecker } from "../../../../../../../tools/ObjectFieldsChecker";
import { MarketplaceListItemDto } from "../../../../../../networking/data/responses/marketplace/buildings/MarketplaceListItemDto";
import { MarketplaceBuildingInfoShort } from "./MarketplaceBuildingInfoShort";
import { MarketplaceBuildingPrice } from "./MarketplaceBuildingPrice";

export class MarketplaceListItem {
    public readonly id: string;
    public readonly building: MarketplaceBuildingInfoShort;
    public readonly price: MarketplaceBuildingPrice;
    public readonly sold: boolean;
    public readonly my: boolean;

    public constructor(mpListItemDto: MarketplaceListItemDto) {
        ObjectFieldsChecker.throwIfInvalidFields(mpListItemDto, [
            "id",
            "building",
            "price",
            "sold",
            "my"
        ]);
        this.id = mpListItemDto.id;
        this.building = new MarketplaceBuildingInfoShort(mpListItemDto.building);
        this.price = new MarketplaceBuildingPrice(mpListItemDto.price);
        this.sold = mpListItemDto.sold;
        this.my = mpListItemDto.my;
    }
}
